import { useCallback, useState } from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import { OnboardingConceptBox } from '../../components/onboarding/OnboardingConceptBox';
import { WizardStepHeader } from '../../components/wizard';
import { useOnboardingFooter } from '../../hooks/useOnboardingFooter';
import { authAPI } from '../../data/auth';
import pt from '../../locales/pt';
import { useAuth } from '../../store/AuthContext';

export function OnboardingWelcome() {
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const [loading, setLoading] = useState(false);

  const onContinue = useCallback(async () => {
    setLoading(true);
    await authAPI.saveOnboardingStep('profile');
    await refreshMe();
    setLoading(false);
    navigate('/onboarding/profile');
  }, [navigate, refreshMe]);

  useOnboardingFooter({
    primaryLabel: pt.onboarding.welcome.cta,
    onPrimary: onContinue,
    loading,
  });

  return (
    <div className="flex flex-col gap-space-6">
      <div className="onboarding-hero h-[172px] rounded-ds-xl">
        <ArrowClockwise className="h-16 w-16 text-sage-500 opacity-85 dark:text-sage-400" aria-hidden />
      </div>
      <WizardStepHeader
        eyebrow={pt.onboarding.welcome.eyebrow}
        title={pt.onboarding.welcome.title}
        subtitle={pt.onboarding.welcome.subtitle}
      />
      <OnboardingConceptBox icon={ArrowClockwise}>{pt.onboarding.welcome.concept}</OnboardingConceptBox>
    </div>
  );
}
